import { IObservableObject, observable } from "mobx";
import { useMemo } from "react";

export function useComputed<T>(getter: () => T): Computed<T> {
  return useMemo(
    () =>
      observable<{ readonly get: T }>({
        get get() {
          return getter();
        },
      }),
    []
  );
}

export type Computed<T> = {
  readonly get: T;
} & IObservableObject;
